import React, { useState, useEffect, useRef, useCallback, useContext } from 'react';
import ItemMaster from '../../../API/APIServices/ItemMaster';
import ItemGroup from '../../../API/APIServices/ItemGroup';
import ConfirmDeletionWithUserInput from '../../Props/ConfirmDeletionWithUserInput';
import CustomizeDeleteService from '../../../API/APIServices/CustomizeDeleteService';
import MyContext from '../../MyContext';
import Account from '../../../API/APIServices/Account';


function ItemGroupCustomizeDelete({ setLoading }) {

    const [productGroupData, setProductGroupData] = useState([]);
    const [pageSize, setPageSize] = useState(50);
    const [page, setPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [isSoftDelete, setIsSoftDelete] = useState(true);
    const [isDeleteItemOfGroups, setIsDeleteItemOfGroups] = useState(true);
    const [isDeleteItemSubGroup, setIsDeleteItemSubGroup] = useState(true);
    const [isDropdownProductGroupName, setIsDropdownProductGroupName] = useState(false);
    const [productGroupSuggestion, setProductGroupSuggestion] = useState([]);
    const [productGroupName, setProductGroupName] = useState("");
    const [selectedProductGroupName, setSelectedProductGroupName] = useState("");
    const [productGroupId, setProductGroupId] = useState(0);


    const dropDownRef = useRef(null);
    const { debounce } = useContext(MyContext);

    async function fetchProductGroup(page_num, product_group_id) {

        setLoading(true);
        try {

            let filterToSend = [];

            if (product_group_id) {

                filterToSend.push({
                    "fieldName": "d2_Id",
                    "operatorName": "equal",
                    "compareValue": product_group_id
                });

            }

            const data = {
                "filter": filterToSend,
                "order": [
                    {
                        "propertyName": "string",
                        "ascending": true
                    }
                ],
                "pageNumber": page_num,
                "pageSize": pageSize
            };

            const response = await ItemGroup.getItemGroupMasters(data);

            if (response.data.isSuccess) {

                const list = response.data.result.map(item => {

                    item.isSelected = false;
                    return item;
                });

                setProductGroupData(list);
                setTotalRecords(response.data.totalRecords);
            } else {
                console.log("Error in fetching product group", response.data.errorMessages);
            }
        } catch (error) {
            console.log("Error in fetching product group", error);
        }

        setLoading(false);
    }

    useEffect(() => {
        fetchProductGroup(page, productGroupId);
    }, [page, productGroupId]);

    function handlePrevClick() {

        if (page <= 1) return;

        setPage(page - 1);
    }

    function handleNextClick() {

        if (page >= Math.ceil(totalRecords / pageSize)) return;

        setPage(page + 1);
    }

    async function handleDelete() {

        setConfirmDeleteOpen(false);
        setLoading(true);

        try {

            const itemGroups_D2Id = productGroupData.filter(item => item.isSelected).map(item => item.d2_Id);


            const data = {
                "itemGroup_D2Id": itemGroups_D2Id,
                "deleteItemSubGroup": isDeleteItemSubGroup,
                "deleteItemOfGroups": isDeleteItemOfGroups,
                "softDelete": isSoftDelete
            }

            console.log("data", data);

            const response = await CustomizeDeleteService.DeleteItemGroupsAsync(data);

            if (response.data.isSuccess) {

                alert("item Group Deleted Successfully!");
                await fetchProductGroup(page, productGroupId);
            } else {
                console.log("Error in Item Group Custom Delete", response?.data?.errorMessages);
                alert("Failed to delete!")
            }

        } catch (e) {
            console.log("Error in Item Group Delete", e?.response?.data?.errorMessages);
            alert("Failed to delete!")
        }

        setLoading(false);
    }

    function handleItemGroupSelect(e, index) {

        const bool = e.target.checked;

        const tempProductGroupData = [...productGroupData];
        tempProductGroupData[index].isSelected = bool;

        setProductGroupData(tempProductGroupData);
    }

    const fetchSuggestions = async (name, value, GroupId, MasterType) => {

        const filteredData = {
            MasterType: MasterType,
            GroupWiseSuggestion: true,
            GroupId: GroupId,
            search_str: value,
            PageNumber: 1,
            PageSize: 50,
        };

        try {
            const SearchItem = await Account.GetAccountListForAutoSuggestion(
                filteredData
            );

            if (SearchItem) {
                return SearchItem;
            } else {
                return [];
            }
        } catch (error) {
            console.error("Error fetching item suggestions:", error);
            return [];
        }
    };

    const debouncedFetchProductGroupSuggestions = useCallback(
        debounce(async (name, value, GroupId) => {
            const SearchItem = await fetchSuggestions(name, value, GroupId, 3);

            setProductGroupSuggestion(SearchItem);
            setIsDropdownProductGroupName(true);

        }, 500),
        []
    );

    const handleProductGroupNameChange = (e) => {

        setProductGroupName(e.target.value);
        setSelectedProductGroupName("");
        setProductGroupId(0);
        debouncedFetchProductGroupSuggestions("ProductGroupName", e.target.value, '');
    }

    const handleProductGroupNameSelection = async (id, name) => {

        console.log(id, name)
        setProductGroupName(name);
        setProductGroupId(id);
        setSelectedProductGroupName(name);
        setIsDropdownProductGroupName(false);
    };


    useEffect(() => {

        function handleClickOutside(event) {

            if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
                setIsDropdownProductGroupName(false)
            }
        }


        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, []);

    return (
        <div className="padding-20">

            <div className="company_info-text-im relative">
                Item Group Deletion
                <button onClick={() => setConfirmDeleteOpen(!confirmDeleteOpen)} className="product-price-account-wise-delete-button customize-delete-button">Delete</button>

            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "5px", marginBottom: "15px" }}>
                <input
                    type="checkbox"
                    name="showPrintOptionPopup"
                    checked={isSoftDelete}
                    onChange={((e) => setIsSoftDelete(e.target.checked))}
                    className="toggle-input"
                    style={{}}
                />

                <span>Soft Delete</span>
                <input
                    type="checkbox"
                    name="showPrintOptionPopup"
                    checked={isDeleteItemOfGroups}
                    onChange={((e) => setIsDeleteItemOfGroups(e.target.checked))}
                    className="toggle-input"
                    style={{}}
                />

                <span>Delete Item Of Groups</span>
                <input
                    type="checkbox"
                    name="showPrintOptionPopup"
                    checked={isDeleteItemSubGroup}
                    onChange={((e) => setIsDeleteItemSubGroup(e.target.checked))}
                    className="toggle-input"
                    style={{}}
                />

                <span>Delete Item Sub Groups</span>
            </div>

            <div className="search_panel_hd1">
                <div style={{ width: "60%" }}>
                    <div className="col-sm-n1" style={{ width: "100%", alignItems: "center" }}>

                        <div ref={dropDownRef} className="group_head" style={{ position: "relative" }}>
                            <input style={{ width: "90%" }} value={productGroupName} onChange={handleProductGroupNameChange} onClick={() => {

                                debouncedFetchProductGroupSuggestions("ProductGroupName", productGroupName, '')
                            }
                            } placeholder="Product Group Name" type="text" className="bill_panel_input" />


                            {isDropdownProductGroupName && (
                                <ul
                                    style={{ position: "absolute", top: "35px" }}
                                    className="ItemmasterDuggestionsaleinvoice"

                                >
                                    {productGroupSuggestion.map((pgName, index) => (
                                        <li
                                            key={index}

                                            onClick={() =>
                                                handleProductGroupNameSelection(
                                                    pgName.id,
                                                    pgName.name
                                                )
                                            }
                                        >
                                            {pgName.name}
                                        </li>
                                    ))}
                                </ul>
                            )}

                        </div>

                    </div>
                </div>


            </div>

            <div className='customize-delete-table-overflow'>
                <table className="lens-stock-table">

                    <thead>
                        <tr>

                            <th style={{ width: "50px" }} className="lens-stock-table-th">S.No.</th>
                            <th style={{ width: "50px" }} className="lens-stock-table-th">Select</th>
                            <th className="lens-stock-table-th">Item Group Id</th>
                            <th className="lens-stock-table-th">Item Group Name</th>

                        </tr>
                    </thead>

                    <tbody>

                        {productGroupData.map((item, index) => {


                            if (index % 2 === 0) {

                                return (
                                    <tr key={index} className="TrLensCreation" style={item.isSelected ? { backgroundColor: "#beddfc" } : {}}>

                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{(pageSize * (page - 1)) + index + 1}</td>

                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">
                                            <input checked={item.isSelected} onChange={(e) => handleItemGroupSelect(e, index)} type="checkbox" />
                                        </td>
                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.d2_Id}</td>
                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.printName || item.name || ""}</td>
                                    </tr>
                                );

                            } else {

                                return (
                                    <tr key={index} className="TrLensCreation customize-delete-alternate-color" style={item.isSelected ? { backgroundColor: "#beddfc" } : {}}>

                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{(pageSize * (page - 1)) + index + 1}</td>

                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">
                                            <input checked={item.isSelected} onChange={(e) => handleItemGroupSelect(e, index)} type="checkbox" />
                                        </td>
                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.d2_Id}</td>
                                        <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.printName || item.name || ""}</td>
                                    </tr>
                                );
                            }

                        })}

                    </tbody>
                </table>
            </div>


            <div style={{ backgroundColor: "#E1EFFD", justifyContent: "end", marginTop: "5px", padding: "10px 0px", borderRadius: "4px" }} className="flex">

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "25%" }}>
                    <button disabled={page <= 1 ? true : false} onClick={handlePrevClick} class="table-list-button">
                        <i class="fa-solid fa-chevron-left"></i>
                    </button>
                    <span class="table-list-page-txt">Page - <strong style={{ margin: "0px 3px;" }}>{page} of {Math.ceil(totalRecords / pageSize)}</strong></span>
                    <button disabled={page >= Math.ceil(totalRecords / pageSize) ? true : false} onClick={handleNextClick} class="table-list-button">
                        <i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>

            </div>

            {confirmDeleteOpen && <ConfirmDeletionWithUserInput
                HeadingTop="Are you sure you want to delete!"
                closeButtonClick={() => { setConfirmDeleteOpen(false) }}
                onYesClick={handleDelete}
            />}

        </div>
    );
}

export default ItemGroupCustomizeDelete;